$(document).ready(function () {
 if (window.location.href.indexOf("products") > -1) {
   if (document.querySelector('input', 'button')) {
     document.querySelectorAll('input', 'button').forEach((elem) => {
       elem.addEventListener("click", function (event) {

         function simulateManualPageReloadWithHistory() {
    setTimeout(function() {
        history.go(0);
    }, 0); // Hier kannst du die Verzögerung in Millisekunden anpassen (hier 1000 Millisekunden = 1 Sekunde)
}

// Aufrufen der Funktion, um das manuelle Aktualisieren zu simulieren
simulateManualPageReloadWithHistory();
         
       });
     });
   }
 }
});
